import { DateTime } from 'luxon'
import { RRuleParser } from './parser'
import { RRule, datetime as rruleDatetime } from 'rrule'

export class OccurrenceGenerator {
  static getOccurrences(
    from: DateTime,
    until: DateTime,
    rrule: string,
    dtstart?: DateTime,
    dtend?: DateTime,
  ) {
    const rruleOptions = RRuleParser.parse(rrule)
    const rule = new RRule({
      freq: rruleOptions.freq,
      interval: rruleOptions.interval,
      byweekday: rruleOptions.byDay,
      dtstart: dtstart
        ? rruleDatetime(
            dtstart.year,
            dtstart.month,
            dtstart.day,
            dtstart.hour,
            dtstart.minute,
            dtstart.second,
          )
        : rruleDatetime(
            from.year,
            from.month,
            from.day,
            from.hour,
            from.minute,
            from.second,
          ),
      until: rruleOptions.until,
      count: rruleOptions.count,
      tzid: 'Europe/Berlin',
    })
    const allOccurrences = rule
      .between(from.toJSDate(), until.toJSDate(), true)
      .map(
        // fix to prevent daylight savings issues
        // https://stackoverflow.com/questions/73409598/rrule-js-recurrence-series-changes-time-of-day-in-time-zone-after-daylight-sav
        (d) =>
          new Date(
            d.getUTCFullYear(),
            d.getUTCMonth(),
            d.getUTCDate(),
            d.getUTCHours(),
            d.getUTCMinutes(),
          ),
      )
    const filteredOccurrences = rruleOptions.exDates?.length
      ? allOccurrences.filter((date) => {
          const currentDate = DateTime.fromJSDate(date)
          return !rruleOptions.exDates?.some(
            (exDate) =>
              exDate.hasSame(currentDate, 'day') &&
              exDate.hasSame(currentDate, 'month') &&
              exDate.hasSame(currentDate, 'year'),
          )
        })
      : allOccurrences
    const occurrences = filteredOccurrences.map((date) => {
      const start = DateTime.fromJSDate(date)
      let end = start
      if (dtstart && dtend) {
        const duration = dtend.diff(dtstart)
        end = start.plus(duration)
      }
      return {
        start: start,
        end: end,
      }
    })
    return occurrences
  }
}
